import { Box, CircularProgress } from "@mui/material";

const FullScreenLoader: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      backgroundColor: "rgba(255, 255, 255, 0.8)",
    }}
  >
    <CircularProgress />
  </Box>
);

export default FullScreenLoader;
